// @ts-nocheck

import React, { useMemo } from 'react';

import useMergeProps from '../../../hooks/useMergeProps';
import MPFamily from '../components/MPFamily';
import { MPFamilyContext } from '../contexts/MPFamilyContext';
import { type MPFamilyId } from '../types/families';

type MPFamilyContainerProps = {
  className?: string;
  familyId: MPFamilyId;
};

const MPFamilyContainer = ({ familyId, ...ownProps }: MPFamilyContainerProps) => {
  const familyIdContextValue = useMemo(
    () => ({
      familyId,
    }),
    [familyId],
  );

  const enhancedProps = useMergeProps({ ownProps });

  return (
    <MPFamilyContext.Provider value={familyIdContextValue}>
      <MPFamily {...enhancedProps} />
    </MPFamilyContext.Provider>
  );
};

export default MPFamilyContainer;
